import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { Utils, Icon } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { VAR_PATTERN } from '@control-front-end/common/constants/regExp';
import mes from './intl';
import FIELDS from '../../Fields';
import Edit from './Items/Edit';
import Select from './Items/Select';
import MultiSelect from './Items/MultiSelect';
import Multi from './Items/Multi';
import Calendar from './Items/Calendar';
import './Panel.scss';

const _ITEMS_ = {
  Edit,
  Select,
  MultiSelect,
  Multi,
  Calendar,
};
// Заморозить объект настроек полей items
const _FIELDS_ = AppUtils.deepFreeze(FIELDS);

class Panel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChangeExtra = this.handleChangeExtra.bind(this);
    this.handleVarChange = this.handleVarChange.bind(this);
    this.handleIdChange = this.handleIdChange.bind(this);
    this.makeError = this.makeError.bind(this);
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  // Создать объект с ошибками
  makeError({ error, id: fieldId, errorId }) {
    const errors = this.props.errors || {};
    if (error) {
      errors[fieldId] = this.i(mes[errorId]);
    } else {
      delete errors[fieldId];
    }
    return Object.keys(errors).length ? errors : undefined;
  }

  // Обработчик изменения extra полей
  handleChangeExtra({ id, value }) {
    const { minDate, maxDate } = value;
    const error = minDate && maxDate ? minDate > maxDate : false;
    const errors = this.makeError({
      error,
      id: 'maxDate',
      errorId: 'notValidMaxDate',
    });
    this.props.onChange({ id, value, errors });
  }

  // Обработчик ввода переменной
  handleVarChange({ id, value }) {
    const regExp = new RegExp(VAR_PATTERN);
    const error = value ? !regExp.test(value) : false;
    const errors = this.makeError({ error, id, errorId: 'wrongVarPattern' });
    this.props.onChange({ id, value, errors });
  }

  // Обработчик ввода ID
  handleIdChange({ id, value }) {
    const { sections, sectionIndex, itemIndex } = this.props;
    let error = false;
    sections.forEach((section) => {
      section.content.forEach((item) => {
        if (
          value === item.id &&
          (item.sectionIndex !== sectionIndex || item.itemIndex !== itemIndex)
        ) {
          error = true;
        }
      });
    });
    const errors = this.makeError({ error, id, errorId: 'notUniqueId' });
    this.props.onChange({ id, value, errors });
  }

  renderItems(items) {
    const { sectionIndex, itemIndex, extra, onChange } = this.props;
    const rItems = [];
    const hasSource =
      extra && extra.optionsSource && extra.optionsSource.type !== 'manual';
    for (const sourceItem of items) {
      if (!sourceItem.class) continue;
      const item = { ...sourceItem };
      const ItemName = Utils.toUpperLatter(item.class);
      const Item = _ITEMS_[ItemName];
      if (!Item) continue;
      const itemVal = this.props[item.id];
      item.value = typeof itemVal === 'undefined' ? item.value : itemVal;
      if (item.options && item.options === 'DYNAMIC') {
        const selectOpt = Array.isArray(this.props.options)
          ? this.props.options.filter((i) => !!i.title)
          : [];
        selectOpt.unshift({ value: '', title: '' });
        selectOpt.push({ value: 'variable', title: 'Variable' });
        item.options = selectOpt;
      }
      item.errors = this.props.errors;
      rItems.push(
        <Item
          key={`${sectionIndex}_${itemIndex}_${item.id}`}
          onChange={item.id === 'extra' ? this.handleChangeExtra : onChange}
          handleVarChange={this.handleVarChange}
          handleIdChange={this.handleIdChange}
          makeError={this.makeError}
          {...item}
          visibility={item.id === 'value' && hasSource ? 'disabled' : 'visible'}
        />
      );
    }
    return rItems;
  }

  renderSections(className) {
    const { onShowPanel, extra } = this.props;
    const hasSource =
      extra && extra.optionsSource && extra.optionsSource.type !== 'manual';
    const itemFields = _FIELDS_[className];
    return Object.keys(itemFields).map((section, index) => {
      if (section === 'options' && hasSource) return null;
      return (
        <div key={section} styleName="panel__section">
          <div styleName="panel__section__title">
            {this.i(mes[`panelTitle_${section}`])}
            {index === 0 ? (
              <Icon
                styleName="panel__section__title__close"
                type="close"
                onClick={onShowPanel}
              />
            ) : null}
          </div>
          <div styleName="panel__section__content">
            {this.renderItems(itemFields[section])}
          </div>
        </div>
      );
    });
  }

  render() {
    const { class: className } = this.props;
    return <div styleName="panel">{this.renderSections(className)}</div>;
  }
}

Panel.propTypes = {
  class: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onShowPanel: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
  sectionIndex: PropTypes.number,
  itemIndex: PropTypes.number,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  extra: PropTypes.object,
  errors: PropTypes.object,
};

Panel.contextTypes = {
  intl: intlShape,
};

export default injectIntl(Panel);
